const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Inventory = {
  readItem: function readInventoryItem (itemId, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/inventory/item/${itemId}`,
      method: 'GET'
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  updateItem: function updateInventoryItem (payload, itemId, token, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/inventory/item/${itemId}`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  },

  deleteItem: function updateInventoryItem (itemId, token, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/inventory/item/${itemId}`,
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    });
  },

  read: function readInventory (spaceId, token, callback, query = '') {
    const requestParams = {
      host: ssoHost,
      path: `/v1/inventory/space/${spaceId}/items/active${query}`,
      method: 'GET',
      headers: {
        Authorization: token ? `Bearer ${token}` : ''
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  create: function createInventoryItem (payload, token, callback) {
    const requestParams = {
      host: ssoHost,
      path: '/v1/inventory/item',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  }
};
